import { render, staticRenderFns } from "./FormSTI.vue?vue&type=template&id=6e0e7b94&scoped=true&"
import script from "./FormSTI.vue?vue&type=script&lang=js&"
export * from "./FormSTI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0e7b94",
  null
  
)

export default component.exports